import {
  getRequest,
  postRequest,
  putRequest,
  putRequestWithFiles,
  getRequestWithParams,
  postRequestWithFiles,
} from "../system/server-call";
import responseHandler from "../system/server-response-handler";
import { globalConstants } from "../constants";

//Get all approved centers list
const getAllCenters = (params) => {
  return postRequest(
    `/${globalConstants.VERSION}/admin/Center/approved`,
    params
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Get all approved centers list
const getAllCentersList = () => {
  return getRequest(`/${globalConstants.VERSION}/admin/center/all`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Get all approval pending centers list
const getApprovalRequestedCenters = (data) => {
  return postRequest(
    `/${globalConstants.VERSION}/admin/Center/pending`,
    data,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Get center profile
const getCenterById = (id) => {
  return getRequest(`/${globalConstants.VERSION}/Center/${id}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Approve center
const approveCenters = (data) => {
  return postRequest(
    `/${globalConstants.VERSION}/admin/Center/approval/center`,
    data,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Approve center spot
const approveCenterSpot = (data) => {
  return postRequest(
    `/${globalConstants.VERSION}/admin/Center/approval/centerSpot`,
    data,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Update Center Profile
const updateCenterProfile = (data) => {
  return putRequest(
    `/${globalConstants.VERSION}/Center/update`,
    data,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Enable Disable center CHNAGE ENDPOINT
const enableDisableCenter = (id) => {
  return putRequest(
    `/${globalConstants.VERSION}/admin/Center/disable/${id}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Update Nafes
const updateNafes = (data) => {
  return putRequestWithFiles(
    `/${globalConstants.VERSION}/Center/update/nafes`,
    data,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const getCenterLogo = (centerId) => {
  return getRequestWithParams(
    `/${globalConstants.VERSION}/Center/logo/${centerId}`,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const uploadCenterLogo = (formData) => {
  return postRequestWithFiles(
    `/${globalConstants.VERSION}/Center/logo`,
    formData
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Add center spot
const addCenterSpot = (data, centerId) => {
  return postRequestWithFiles(
    `/${globalConstants.VERSION}/Center/centerSpot/${centerId}`,
    data,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Edit private center spot
const editPrivateCenterSpot = (data) => {
  return putRequest(
    `/${globalConstants.VERSION}/Spot/private/update`,
    data,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Edit public center spot
const editPublicCenterSpot = (data) => {
  return putRequest(
    `/${globalConstants.VERSION}/Spot/public/centerSpot/update`,
    data,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Get center spot by id
const getCenterSpotById = (id) => {
  return getRequest(`/${globalConstants.VERSION}/Spot/centerSpots/${id}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const exportCenterData = (gridState, requestType) => {
  return postRequest(
    `/${globalConstants.VERSION}/admin/Center/export/centers/${requestType}`,
    gridState
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const centerPayment = (checkout) => {
  return getRequest(
    `/${globalConstants.VERSION}/Center/payment/${checkout}`,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const centerPaymentWithSavedCard = (data) => {
  return postRequest(
    `/${globalConstants.VERSION}/Center/savedCard/payment`,
    data,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const centerReApprovalRequest = (centerId) => {
  return putRequest(
    `/${globalConstants.VERSION}/Center/reApproval/${centerId}`,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const updateCenterHeadInstructorDetail = (data) => {
  return putRequestWithFiles(
    `/${globalConstants.VERSION}/Center/headInstructor`,
    data,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const cancelMembership = (centerId) => {
  return putRequest(
    `/${globalConstants.VERSION}/Center/cancel/${centerId}`,
    {},
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

export const centersService = {
  getAllCenters,
  getAllCentersList,
  getCenterById,
  getApprovalRequestedCenters,
  approveCenters,
  approveCenterSpot,
  updateCenterProfile,
  enableDisableCenter,
  updateNafes,
  getCenterLogo,
  uploadCenterLogo,
  addCenterSpot,
  editPublicCenterSpot,
  editPrivateCenterSpot,
  getCenterSpotById,
  exportCenterData,
  centerPayment,
  centerPaymentWithSavedCard,
  centerReApprovalRequest,
  updateCenterHeadInstructorDetail,
  cancelMembership,
};
